import React, {useRef, useState} from 'react';
import {useAuth0} from "@auth0/auth0-react";
import DataGrid from "../../../controls/DataGrid";
import {withStyles} from "@material-ui/core/styles";
import __ from "lodash";
import {useQueryClient} from "react-query";

const styles = {
  bookingQueueFormDimensionsCell: {
    fontSize: 12,
    paddingLeft: "3px !important",
    paddingRight: "3px !important",
  },
  bookingQueueFormDimensionsHeader: {
    fontSize: 12,
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
  }
};


const TimingsGrid = (_props) => {
  const {isAuthenticated} = useAuth0();
  const props = {
    ..._props
  }

  const { classes } = props;
  const queryClient = useQueryClient();

  const dataGridRef = useRef();
  const [timings, setTimings] = useState(props.timings);
  if ( !__.isEqual(timings, props.timings) )
    setTimings(props.timings);

  const onGridReady = (params) => {
    params.api.sizeColumnsToFit();
    if (props.onGridReady) {
      props.onGridReady(params);
    }
  };

  const updateParent = (params) => {
    let model;
    let visibleRows = [];
    if(params.api){
      model = params.api.getModel();
      visibleRows = model.rowsToDisplay;
    }

    const timings = [];
    visibleRows.forEach(row => {
      timings.push(row.data);
    });

    if (props.onChange) {
      props.onChange(timings);
    }
  }

  const getColumns = (props) => {
    const baseColumn = {
      options: {
        //cellStyle: { fontSize: 7, },
        //cellClass: classes.column,
        //headerClass: classes.header,
      },
      editable: props.canEdit,
      //headerClass: 'classes'
    };

    return [
      {
        ...baseColumn,
        headerName: "Direction",
        field: "outbound",
        width: 150,
        editable: false,
        //maxWidth: 50,
        // flex: 1,
        valueFormatter: (params) => {
          return (params.node.data.outbound ? "Outbound" : "Inbound");
        }
      },
      {
        headerName: "Cargo profile",
        ...baseColumn,
        field: "cargoProfileCode",
        width: 250,
        summary: false,
        editable: false,
        cellEditor: {
          component: "ComboSelect",
          params: {
            id: "cargoProfileCode",
            //isdatagrid: true,
            displayOnly: true,
            value: props.value,
            group: "CARGO LOAD PROFILE",
            subGroup: "",
            style: {width:"100%", fontSize: "0.875rem", textAlign: "left"},
          }
        },
        valueFormatter: (params) => {
          const combos = queryClient.getQueryData(['ComboValues', "CARGO LOAD PROFILE", ""]);
          if (combos) {
            const selectedCombo = __.find(combos, {code: params.node.data.cargoProfileCode});
            if (selectedCombo && !__.isEmpty(selectedCombo)) {
              const {value} = selectedCombo;
              return value;
            }
          }
          return params.value;
        },
      },
      {
        ...baseColumn,
        headerName: "Duration (minutes)",
        field: "durationMinutes",
        editable: props.canEdit,
        //width: 100,
        //maxWidth: 50,
        flex: 1,
        onCellValueChanged: updateParent,
      },
    ];
  };

  return (isAuthenticated &&
    <div style={{width: props.width?props.width:"100%", ...props.style}}>
      <DataGrid
        title="Turnround Timings"
        ref={dataGridRef}
        columns={getColumns({canEdit: props.canEdit})}
        rows={timings}
        height={props.height||`calc(100vh - ${(290)}px)`}
        options={{
          singleClickEdit: true,
          stopEditingWhenCellsLoseFocus: true,
          editType:'fullRow',
          //onCellValueChanged: ()=>{ }, //prevent default onCellValueChanged
          defaultColDef: {
            editable: false,
            resizable: false,
            menuTabs: []
          }
        }}
        onGridReady={onGridReady}
      />
    </div>
  );

}

export default withStyles(styles)(TimingsGrid);
